import Head from "next/head";
import { useMemo } from "react";
import type { Event } from "src/types";

import { getEventMetadata } from "@/utils/event-metadata";

type EventMetaTagsProps = {
  event: Event;
};

export default function EventMetaTags({ event }: EventMetaTagsProps) {
  const { title, description, pageUrl, imageUrl } = useMemo(
    () => getEventMetadata(event),
    [event]
  );

  return (
    <Head>
      <title>{title}</title>
      {event.favicon_url && (
        <link
          rel="icon"
          data-testid="custom-favicon"
          href={event.favicon_url}
        />
      )}
      {!event.favicon_url && <link rel="icon" href="/canvas/favicon.ico" />}

      <meta name="title" content={title} />
      <meta name="description" content={description} />

      <meta property="og:type" content="website" />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {imageUrl && <meta property="og:image" content={imageUrl} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={pageUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      {event.event_type === "hidden_event" ||
      event.event_type === "private_event" ? (
        <meta name="robots" content="noindex" />
      ) : null}
    </Head>
  );
}
